import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'

type TooltipDataTableRow = {
  label: string
  values: string[]
}

type TooltipDataTableProps = {
  title?: string
  labelHeader?: string
  columns: string[]
  rows: TooltipDataTableRow[]
}

const cellSx = {
  borderColor: 'rgba(255,255,255,0.16)',
  color: 'inherit',
  fontSize: '0.75rem',
  lineHeight: 1.2,
  px: 1,
  py: 0.5,
}

const TooltipDataTable = ({ title, labelHeader = '', columns, rows }: TooltipDataTableProps) => {
  return (
    <Box sx={{ minWidth: 240 }}>
      {title && (
        <Typography variant="caption" sx={{ display: 'block', mb: 0.75 }}>
          {title}
        </Typography>
      )}

      <Table size="small" sx={{ '& .MuiTableCell-root': cellSx }}>
        <TableHead>
          <TableRow>
            <TableCell>{labelHeader}</TableCell>
            {columns.map(column => (
              <TableCell key={column} align="right">
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.label}>
              <TableCell component="th" scope="row">
                {row.label}
              </TableCell>
              {row.values.map((value, index) => (
                <TableCell key={`${row.label}-${columns[index] ?? index}`} align="right">
                  {value}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export default TooltipDataTable
